var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.initData.topicId
          ? _vm.$t("COMMON_EDIT")
          : _vm.$t("PAGE_PBC_ADD_TOP"),
        visible: "",
        width: "60%",
      },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "180px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("TABLE_HEADER_topicName"), prop: "name" },
            },
            [
              _c("el-input", {
                attrs: { maxlength: "100" },
                model: {
                  value: _vm.ruleForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "name", $$v)
                  },
                  expression: "ruleForm.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("PAFE_PBC_LIST_DESC"),
                prop: "description",
              },
            },
            [
              _c("el-input", {
                staticClass: "text-area-cls",
                attrs: {
                  type: "textarea",
                  maxlength: "250",
                  "show-word-limit": "",
                  rows: 4,
                },
                model: {
                  value: _vm.ruleForm.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "description", $$v)
                  },
                  expression: "ruleForm.description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "wl-grey", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary" },
              on: { click: _vm.onConfirm },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.initData.topicId
                    ? _vm.$t("btn_confirm")
                    : _vm.$t("COMMON_ADD")
                )
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }